<template>
  <generic-update-list
    v-bind="{ model, modelHeaders, modelFk, defaultItem, filters }"
  >
    <template v-slot:form="{ editedItem, error }">
      <v-row>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="editedItem.code"
            :error-messages="error.code"
            :readonly="!profile.is_staff"
            label="Codice"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="editedItem.short_title"
            :error-messages="error.short_title"
            :readonly="!profile.is_staff"
            label="Titolo interno"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="editedItem.title"
            :error-messages="error.title"
            :readonly="!profile.is_staff"
            label="Titolo"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <v-text-field
            v-model="editedItem.length"
            :error-messages="error.length"
            :readonly="!profile.is_staff"
            label="Durata"
          ></v-text-field>
        </v-col>
        <v-col cols="12" sm="4">
          <autocomplete
            v-model="editedItem.categories"
            clearable
            :error-messages="error.categories"
            :model="concertCategoryModel"
            :extra-params="modelFk"
            item-text="name"
            item-value="id"
            :readonly="!profile.is_staff"
            label="Percorsi"
            multiple
          ></autocomplete>
        </v-col>
        <v-col cols="12" sm="4">
          <autocomplete
            v-model="editedItem.people"
            :error-messages="error.people"
            :model="showPersonModel"
            :extra-params="modelFk"
            item-text="person__name"
            item-value="id"
            label="Musicisti"
            :readonly="!profile.is_staff"
            multiple
          ></autocomplete>
        </v-col>
        <v-col cols="12" sm="4">
          <autocomplete
            v-model="editedItem.instruments"
            :error-messages="error.instruments"
            :model="showInstrumentModel"
            :extra-params="modelFk"
            item-text="instrument__name"
            item-value="id"
            label="Strumenti"
            :readonly="!profile.is_staff"
            multiple
          ></autocomplete>
        </v-col>
        <v-col cols="12" sm="4">
          <autocomplete
            v-model="editedItem.bands"
            :error-messages="error.bands"
            :model="showBandModel"
            :extra-params="modelFk"
            item-text="band__name"
            item-value="id"
            label="Gruppi"
            :readonly="!profile.is_staff"
            multiple
          ></autocomplete>
        </v-col>
        <v-col cols="12" sm="4">
          <v-textarea
            v-model="editedItem.description"
            :error-messages="error.description"
            :readonly="!profile.is_staff"
            label="Descrizione"
          ></v-textarea>
        </v-col>
        <v-col v-if="profile.is_staff" cols="12" sm="4">
          <v-textarea
            v-model="editedItem.preparation_notes"
            :error-messages="error.preparation_notes"
            :readonly="!profile.is_staff"
            label="Note di allestimento"
          ></v-textarea>
        </v-col>
        <v-col v-if="profile.is_staff" cols="12" sm="4">
          <v-textarea
            v-model="editedItem.box_office_notes"
            :error-messages="error.box_office_notes"
            label="Note di box office"
            :readonly="!profile.is_staff"
          ></v-textarea>
        </v-col>
      </v-row>
    </template>
  </generic-update-list>
</template>

<script>
import models from "@/models"

export default {
  data() {
    return {
      modelHeaders: [
        { text: "Codice", value: "code" },
        { text: "Titolo interno", value: "short_title" },
        { text: "Titolo", value: "title" },
      ],
      model: models.Concert,
      showBandModel: models.ShowBand,
      concertCategoryModel: models.ConcertCategory,
      showInstrumentModel: models.ShowInstrument,
      showPersonModel: models.ShowPerson,
      filters: [
        { name: "people", model: models.ShowPerson, text: "person__name" },
        { name: "bands", model: models.ShowBand, text: "band__name" },
        {
          name: "categories",
          model: models.ConcertCategory,
          text: "name",
        },
        // { name: "roles", model: models.PersonRole, text: "name" },
        // { name: "instruments", model: models.Instrument, text: "name" },
      ],
    }
  },
  computed: {
    modelFk() {
      return { show: this.$route.params.id }
    },
  },
  methods: {
    defaultItem: () => ({
      code: "",
      short_title: "",
      title: "",
      length: "",
      description: "",
      categories: [],
      people: [],
      bands: [],
      instruments: [],
      preparation_notes: "",
      box_office_notes: "",
    }),
  },
}
</script>
